import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';
import ActiveTabTitle from './activeTabTitle';

const enhance = compose(
  withNamespaces(['common']),
);

export default enhance(ActiveTabTitle);
